import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { IconStar } from "components/Icon";
import useLanguageProvider from "components/LanguageProvider/hooks/useLanguageProvider";
import FeaturedByCard from "./components/FeaturedByCard/FeaturedByCard";
import FeaturedByModal from "./components/FeaturedByModal/FeaturedByModal";
import "./_style.scss";
function FeaturedBy({ featuredByLink, paymentUrl }) {
    const { translate: t } = useLanguageProvider();
    const [isModalOpen, setIsModalOpen] = useState(false);
    if (!featuredByLink) {
        return null;
    }
    return (_jsxs("section", { className: "featured-by", children: [_jsxs("div", { className: "featured-by__heading", children: [_jsx(IconStar, { "aria-hidden": "true" }), _jsx("h2", { className: "featured-by__heading-title", children: t("FEATURED BY") }), _jsx("span", { className: "featured-by__heading-info", title: t("This campaign has been mentioned by external sources"), "aria-hidden": "true", children: "\u24D8" })] }), _jsx(FeaturedByCard, { featuredByLink: featuredByLink, onClick: () => setIsModalOpen(true) }), isModalOpen && (_jsx(FeaturedByModal, { featuredByLink: featuredByLink, paymentUrl: paymentUrl, onClose: () => setIsModalOpen(false) }))] }));
}
export default FeaturedBy;
